'use client';

import { RefObject, useRef } from 'react';
import cn from 'classnames';
import useClickOutside from '@/hooks/useClickOutside';
import { ShadowBox } from '@/ui-components/atoms/ShadowBox/ShadowBox';
import styles from './snapshotpopover.module.scss';

interface SnapshotPopoverShellProps {
    ariaLabel: string;
    buttonRef: RefObject<HTMLButtonElement | null>;
    children: React.ReactNode;
    onClose: () => void;
    open: boolean;
    className?: string;
}

export function SnapshotPopoverShell({
    ariaLabel,
    buttonRef,
    children,
    onClose,
    open,
    className,
}: SnapshotPopoverShellProps): React.JSX.Element | null {
    const wrapperRef = useRef<HTMLDivElement>(null);

    useClickOutside(
        wrapperRef,
        {},
        () => {
            if (open) {
                onClose();
            }
        },
        buttonRef,
    );

    if (!open) {
        return null;
    }

    return (
        <div
            ref={wrapperRef}
            className={cn(styles.snapshotPopover, className)}
            role="dialog"
            aria-modal="false"
            aria-label={ariaLabel}
        >
            <ShadowBox targetClass={styles.snapshotPopoverCard} roundedBorder={true}>
                {children}
            </ShadowBox>
        </div>
    );
}
